// ./src/components/generic/TestPaymentsControl/TestPaymentsControl.tsx
//
// #204 / #281 — the "Real · Test · All" facet of a money list (gifts, monthly donors, memberships). A record bought
// with a test card (`isTest`) is practice: the list opens on REAL ones, Test shows only the practice ones, All both.
// One control so the three lists read the same; the page maps the view to its server filter with `isTestFilterOf`.
import React, { useMemo } from "react";
import { SegmentedControl } from "@mantine/core";
import { useTranslation } from "react-i18next";

export type PaymentsView = "real" | "test" | "all";

/** Where every list opens: real records only. */
export const DEFAULT_PAYMENTS_VIEW: PaymentsView = "real";

/** The server's `isTest` filter for a view — `undefined` (no filter) for All. */
export const isTestFilterOf = (view: PaymentsView): boolean | undefined => (view === "all" ? undefined : view === "test");

export interface TestPaymentsControlProps {
  value: PaymentsView;
  onChange: (next: PaymentsView) => void;
  disabled?: boolean;
  fullWidth?: boolean;
}

export const TestPaymentsControl: React.FC<TestPaymentsControlProps> = ({ value, onChange, disabled, fullWidth }) => {
  const { t } = useTranslation(["common"]);

  const data = useMemo(
    () => [
      { value: "real", label: t("common:payments.real", { defaultValue: "Real" }) },
      { value: "test", label: t("common:payments.test", { defaultValue: "Test" }) },
      { value: "all", label: t("common:payments.all", { defaultValue: "All" }) },
    ],
    [t]
  );

  return (
    <SegmentedControl
      data={data}
      value={value}
      onChange={(next) => onChange(next as PaymentsView)}
      disabled={disabled}
      fullWidth={fullWidth}
      aria-label={t("common:payments.label", { defaultValue: "Payments" })}
      size="md"
    />
  );
};
